// app entry
import '@@/core/polyfill'


import('./bootstrap');

// generated at 2026/7/7 19:44:20 by sui v3.1.117